var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FixedChattingPanel',[[_c('ChzzkChattingPanel',{ref:"panel",on:{"onUserInput":_vm.onUserInput,"on":_vm.onChat,"donation":_vm.onDonation}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }